import * as React from 'react';
import {StyleSheet, View, TouchableWithoutFeedback} from 'react-native';
import Styles from '../../Styles';
import AVText from '../AVText';
import Localized from 'src/constants/AppStrings';
import {getDescriber as getSnackDescriber} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';
import {RewardCashType} from 'src/types/Rewards';
import AVFormattedCurrency from 'src/components/elements/AVFormattedCurrency';
import AccountStore from 'src/stores/AccountStore';
import {RewardTier} from 'src/types/RewardsModel';
import {getFooterDescriber} from 'src/components/elements/footerDescriptor/DescriptorType';
import CashRewardsIcon from 'src/components/img/svg/rewards/CashRewardsIcon';

type CashRewardTileProps = {
  rewardItem: RewardCashType;
  tier: RewardTier;
  onRewardPress: (item: RewardCashType, pointsRequired: number) => void;
};
const lineHeightMultiplier = 1.14;
export default function CashRewardTile(props: CashRewardTileProps) {
  const {rewardItem, tier, onRewardPress} = props;
  return (
    <TouchableWithoutFeedback
      onPress={() => {
        !tier.isLocked && onRewardPress(rewardItem, tier.pointsRequired);
      }}
    >
      <View
        style={[styles.productItemParent, styles.tile]}
        accessible
        nativeID="qa_btn_RewardsItem"
        testID="qa_btn_RewardsItem"
      >
        <View
          accessibilityLabel={rewardItem.cashAmount.toString()}
          accessibilityRole="button"
          style={[styles.productItem, tier.isLocked && styles.disabled]}
        >
          <View style={styles.cashIconView}>
            <CashRewardsIcon color={getFooterDescriber().bottomTabBtnColor()} />
          </View>
          <AVText
            numberOfLines={3}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
            style={[
              styles.productName,
              getSnackDescriber()?.snackDetailsBtnFontSTyle(),
            ]}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
          >
            <AVFormattedCurrency
              value={rewardItem.cashAmount}
              currency={AccountStore.getCurrency()}
              style={[
                styles.productName,
                getSnackDescriber()?.snackDetailsBtnFontSTyle(),
              ]}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
            />
            {' ' + Localized.Labels.credit}
          </AVText>
        </View>
      </View>
    </TouchableWithoutFeedback>
  );
}
const styles = StyleSheet.create({
  productItem: {
    width: 164,
    height: 170,
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    paddingHorizontal: Styles.Spacing.m3 - 4,
    paddingTop: Styles.Spacing.m3,
    paddingBottom: Styles.Spacing.m4,
    borderRadius: Styles.Spacing.m2,
    borderColor: Styles.Colors.PayNew.neutralHuesBase11,
    backgroundColor: Styles.Colors.PayNew.white01,
    borderWidth: 1,
  },
  productItemParent: {
    flexDirection: 'column',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingBottom: 16,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: '#E7E7E7',
    backgroundColor: '#FFF',
    shadowColor: 'black',
    shadowOffset: {width: 0, height: 4},
    shadowOpacity: 0.07,
    shadowRadius: 4,
    elevation: 3,
  },
  productName: {
    width: '100%',
    flexGrow: 1,
    textAlign: 'center',
    fontSize: Styles.Fonts.f1 - 2,
    fontWeight: '700',
    lineHeight: (Styles.Fonts.f1 - 2) * lineHeightMultiplier,
    marginTop: Styles.Spacing.m0,
  },
  price: {
    fontSize: Styles.Fonts.f7,
    fontWeight: '700',
    textAlign: 'center',
    color: getFooterDescriber().bottomTabBtnColor(),
    width: 66,
  },
  cashIconView: {
    width: 68,
    height: 68,
    borderRadius: 34,
    alignItems: 'center',
    justifyContent: 'center',
  },
  tile: {
    width: 164,
    height: 170,
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    paddingHorizontal: Styles.Spacing.m3 - 4,
    paddingBottom: Styles.Spacing.m4,
    borderRadius: Styles.Spacing.m2 + 2,
    borderColor: Styles.Colors.PayNew.neutralHuesBase11,
    backgroundColor: Styles.Colors.PayNew.white01,
    borderWidth: 1,
  },
  disabled: {
    opacity: 0.6,
  },
});
